import Typography from '@mui/material/Typography';

import classes from './classes.module.scss';

const Header = props => {
  const {
    header,
    fullWidth
  } = props;

  let sx = {};
  if (fullWidth) {
    sx.width = '100%';
  }

  return (
    <Typography
      className={classes.header}
      variant="h1"
      sx={sx}
    >
      {header}
    </Typography>
  );
}

export default Header;
